module.exports = __webpack_public_path__ + "img/tz2.9252fb31.png";